<template>

    <div class="phase">
        <div class="floor">
            <div class="plain">
                <div class="side">
                    <div class="round-blue">{{ number }}</div>
                </div>
                <markdown class="title" :text="title"></markdown>
            </div>

            <div class="plain">
                <div class="side"></div>
                <div class="plain-column">
                    <markdown class="subtitle" :text="subtitle"></markdown>
                    <button v-show="subtitleCta" @click="$emit('action')">{{ $t('web_google_connexion_step2_subtitle_click') }}</button>
                </div>
            </div>
        </div>

        <div v-if="image" class="basement">
            <img :src="image" class="image">
        </div>
    </div>

</template>

<script>
import Markdown from '../../../components/Markdown'

export default {

    name: 'login-flow-google-phase',

    props: {
        number: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        subtitleCta: {
            type: Boolean,
            default: false
        },
        image: {
            type: String,
            default: ''
        }

    },

    components: {Markdown}

}
</script>

<style lang="scss" scoped>

.phase {
    margin-top: 8px;
    border-radius: 20px;
    border: 1px solid #E0F1FC;
    text-align: start;
    overflow: hidden;

    @media screen and (min-width: $above-tablet-length) {
        margin-top: 16px;
    }

    .floor {
        padding: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        @media screen and (min-width: $above-tablet-length) {
            padding: 20px;
        }

        .plain {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-start;
            align-items: flex-start;

            .side {
                min-width: 24px;

                .round-blue {
                    width: 24px;
                    height: 24px;
                    background-color: $aquamarine;
                    border-radius: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: $white;
                    font-size: 15px;
                    font-weight: 500;
                }

            }

            .title {
                margin: 0 8px;
                font-size: 15px;
                font-weight: 400;
                @media screen and (min-width: $above-tablet-length) {
                    font-size: 20px;
                    line-height: 28px;
                }
            }

            .subtitle {
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                color: $neutralsMoon;
                @media screen and (min-width: $above-tablet-length) {
                    font-size: 17px;
                    line-height: 24px;
                }
            }

            .plain-column {
                margin: 4px 8px 0;
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                button {
                    color: $aquamarine;
                    font-family: $font-primary;
                    background-color: $white;
                    font-weight: 600;
                    line-height: 24px;
                    text-decoration-line: underline;
                    @media screen and (min-width: $above-tablet-length) {
                        font-size: 17px;
                    }
                }
            }

        }
    }

    .basement {
        height: 140px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-bottom: 10px;
        background: linear-gradient(181deg, #86C4EB 0.91%, #99CCEC 99.09%);

        @media screen and (min-width: $above-tablet-length) {
            align-items: flex-end;
            justify-content: flex-end;
            padding: 32px 0 0;
        }


        .image {

        }
    }
}

</style>
